import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconMail = props => (
  <SvgIcon {...props} viewBox="0 0 20 16">
    <path d="m18 0h-16c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h16c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zm0 4-8 5-8-5v-2l8 5 8-5v2z" />
  </SvgIcon>
);

export default IconMail;



// WEBPACK FOOTER //
// ./src/components/icons/IconMail.js